import React, {FC} from 'react';
import styled, {keyframes} from 'styled-components';

import {VisualSizesEnum} from '../../../libs/shared/ui/src/styles/commonStyles';
import {makeSizeConstants} from '../../../libs/shared/ui/src/styles/styleHelpers';

/*
 * Props.
 */

interface ThreeDotsProps {
  color: string;
  size: VisualSizesEnum;
}

/*
 * Style.
 */

const opacityPulseAnimation = keyframes`
  0%, 100%
  {
    opacity: .3;
  }

  60%
  {
    opacity: 1;
  }
`;

interface ThreeDotsStyleProps {
  $size: VisualSizesEnum;
  $color: string;
}

const StyledDotsWrapper = styled.div`
  display: flex;
  flex-shrink: 0;
`;

const dotSizes = makeSizeConstants(4, 6);
const dotMargins = makeSizeConstants(2, 3);

const StyledDotDiv = styled.div<ThreeDotsStyleProps>`
  height: ${(p) => dotSizes[p.$size]}px;
  width: ${(p) => dotSizes[p.$size]}px;

  /* Inter-dot spacing. */
  & + & {
    margin-left: ${(p) => dotMargins[p.$size]}px;
  }

  background-color: ${(p) => p.$color};
  border-radius: 50%;

  /* Stacked animation. */
  animation: ${opacityPulseAnimation} 1.5s infinite;
  animation-delay: 150ms;

  &:nth-of-type(2) {
    animation-delay: 250ms;
  }

  &:nth-of-type(3) {
    animation-delay: 350ms;
  }
`;

/*
 * Component.
 */

export const ThreeDots: FC<ThreeDotsProps> = (props) => (
  <StyledDotsWrapper>
    <StyledDotDiv $size={props.size} $color={props.color} />
    <StyledDotDiv $size={props.size} $color={props.color} />
    <StyledDotDiv $size={props.size} $color={props.color} />
  </StyledDotsWrapper>
);
